'use client';

import { SignInButton } from '@clerk/nextjs';
import { useTranslations } from 'next-intl';

import { track } from '../../libs/observability/analytics.client';
import { WEB_EVENTS } from '../../libs/observability/attributes';

/**
 * "Continue with GitHub" button. Opens Clerk's sign-in flow (configure GitHub
 * as the provider in the Clerk dashboard). On success the modal closes and the
 * homepage re-renders signed in (avatar + dashboard link). The styled button is
 * kept as SignInButton's child so the look is unchanged.
 */
export function GitHubSignInButton(): React.JSX.Element {
  const t = useTranslations('home');

  return (
    <SignInButton mode="modal">
      <button
        type="button"
        onClick={(): void => track(WEB_EVENTS.githubSignInClicked)}
        className="inline-flex items-center justify-center gap-3 rounded-xl bg-[#2D1666] px-7 py-3.5 text-base font-semibold text-white shadow-lg transition-colors hover:bg-[#3a1d85] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#8347E0] focus-visible:ring-offset-2"
      >
        <GitHubMark />
        {t('continueWithGitHub')}
      </button>
    </SignInButton>
  );
}

function GitHubMark(): React.JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 .5C5.73.5.5 5.73.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.56 0-.27-.01-1.16-.02-2.1-3.2.7-3.88-1.36-3.88-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.29 1.19-3.1-.12-.29-.52-1.46.11-3.05 0 0 .97-.31 3.18 1.18a11.1 11.1 0 0 1 5.8 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.59.23 2.76.11 3.05.74.81 1.19 1.84 1.19 3.1 0 4.42-2.69 5.39-5.25 5.68.41.36.78 1.07.78 2.16 0 1.56-.01 2.82-.01 3.2 0 .31.21.68.8.56A10.53 10.53 0 0 0 23.5 12C23.5 5.73 18.27.5 12 .5Z" />
    </svg>
  );
}
